import sidebarReducer from './sidebar/sidebar.reducer';
import {reducer as formReducer } from 'redux-form';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  sidebar: sidebarReducer,
  form: formReducer,
})

export default rootReducer;